// Notificacao push do navegador (Web Push/VAPID) -- usado pelo "Lembrete
// devocional" no Perfil. Mantido separado de PrototypeApp.js por ser uma
// integracao de plataforma (Notification API, Service Worker, PushManager),
// nao estado de tela.
import { apiGet, apiPost } from "./api/client";

export function isPushSupported() {
  return typeof window !== "undefined" && "serviceWorker" in navigator && "PushManager" in window && "Notification" in window;
}

// PushManager.subscribe() exige a VAPID public key como Uint8Array (curva
// P-256 nao-comprimida), nao como a string base64url que a API devolve.
function urlBase64ToUint8Array(base64String) {
  const padding = "=".repeat((4 - (base64String.length % 4)) % 4);
  const base64 = (base64String + padding).replace(/-/g, "+").replace(/_/g, "/");
  const rawData = window.atob(base64);
  const outputArray = new Uint8Array(rawData.length);
  for (let i = 0; i < rawData.length; i++) outputArray[i] = rawData.charCodeAt(i);
  return outputArray;
}

/**
 * Pede permissao de notificacao (se ainda nao concedida/negada) e cria a
 * inscricao push, enviando-a pro backend. Lanca erro com mensagem amigavel
 * em cada ponto de falha esperado (sem suporte, permissao negada, etc.) --
 * quem chama decide como mostrar isso (ver updateDevotionalReminder em
 * PrototypeApp.js).
 */
export async function subscribeToPushReminders() {
  if (!isPushSupported()) {
    throw new Error("Este navegador não suporta notificações push.");
  }

  if (Notification.permission === "denied") {
    throw new Error("As notificações estão bloqueadas para este site nas configurações do navegador.");
  }

  const permission = Notification.permission === "granted" ? "granted" : await Notification.requestPermission();
  if (permission !== "granted") {
    throw new Error("Permissão de notificação não concedida.");
  }

  const { publicKey } = await apiGet("/push/vapid-public-key");
  if (!publicKey) throw new Error("Notificações push não estão configuradas no momento.");

  const registration = await navigator.serviceWorker.ready;
  let subscription = await registration.pushManager.getSubscription();
  if (!subscription) {
    subscription = await registration.pushManager.subscribe({
      userVisibleOnly: true,
      applicationServerKey: urlBase64ToUint8Array(publicKey)
    });
  }

  await apiPost("/push/subscribe", { body: subscription.toJSON() });
  return subscription;
}

/**
 * Remove a inscricao push local e avisa o backend (best-effort -- se a API
 * falhar, a inscricao local ja foi cancelada, entao o navegador nao vai mais
 * receber pushes de qualquer forma).
 */
export async function unsubscribeFromPushReminders() {
  if (!isPushSupported()) return;
  const registration = await navigator.serviceWorker.ready;
  const subscription = await registration.pushManager.getSubscription();
  if (!subscription) return;

  const endpoint = subscription.endpoint;
  await subscription.unsubscribe().catch(() => {});
  await apiPost("/push/unsubscribe", { body: { endpoint } }).catch(() => {});
}
